import { FC } from 'react';

import { Modal } from '@rikstv/play-common/src/components/modal/Modal';
import { H1 } from '@rikstv/shared-components';

import { ContentStackMetadata, ProviderVariant, VariantSection } from '../contentStack.types';
import { useProviderVariants } from '../hooks/useProviderVariants';

import { ProviderVariantList } from './ProviderVariantSection';

import styles from './ProviderVariantModal.module.css';

type Props = {
  stack: ContentStackMetadata;
  isOpen: boolean;
  onClose: () => void;
  onSelectProvider: (variant: ProviderVariant) => void;
};
export const ProviderVariantModal: FC<Props> = ({ stack, isOpen, onClose, onSelectProvider }) => {
  const { data } = useProviderVariants(stack._links.providerVariants.href);
  // TODO: handle actual error from request?
  // TODO: fallback here only used since API respond 500 for episode-variants
  const _data =
    data ?? (stack.sections.find(s => s.type === 'providerVariants') as VariantSection | undefined)?.providerVariants;

  return (
    <Modal open={isOpen} center onClose={onClose}>
      {_data && (
        <div data-testid="provider-variant-modal" className={styles.modalWrapper}>
          <H1 lookLike="title-2">{_data.title}</H1>
          <br />
          <br />
          <ProviderVariantList variants={_data.variants} onSelectVariant={onSelectProvider} />
        </div>
      )}
    </Modal>
  );
};
